import { axios } from "@/client/libs/axios";

export const fixGrammar = async (text: string) => {
  const response = await axios.post<{ text: string }>("/ai/fix-grammar", { text });

  return response.data.text;
};
